<ui-card>
    <app-segment-header title="Indeed Quick Apply"></app-segment-header>
    <p>
        Jobs with Quick Apply enabled on Indeed are more likely to receive more applicants.
        <br />
        <strong>
            Note: Jobs with Quick Apply enabled will remove the custom questions and document requests for the job
            posting you created.
        </strong>
    </p>
    <mat-checkbox
        [(ngModel)]="integrationIndeed.isQuickApplyEnabled"
        name="quick-apply"
        type="checkbox"
        class="columns-4 small-columns-12"
    >
        Allow applicants to use Quick Apply on Indeed for all active jobs
    </mat-checkbox>
</ui-card>
